import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

/**
 * Krok NAP8 bod 1 (A18) — REGISTR NEPLATNYCH DOKLADU (MV CR) z adminu.
 *
 * CISLO DOKLADU JE PRECHODNY ARGUMENT: jde z formulare do requestu a tim
 * konci. Tenhle modul si ho NIKAM neuklada (zadny stav, zadny cache) a
 * odpoved uz cele cislo nenese — jen posledni ctyri znaky.
 */

export type DocumentCheckType = 'id_card' | 'passport' | 'firearms_licence';

/** Druhy dokladu v poradi, v jakem je nabizi karta. */
export const DOCUMENT_CHECK_TYPES: readonly DocumentCheckType[] = [
  'id_card',
  'passport',
  'firearms_licence',
];

export interface DocumentCheckResultDto {
  /** `true` = doklad JE v registru neplatnych, `false` = neni, `null` = nevime. */
  readonly registered: boolean | null;
  readonly documentType: DocumentCheckType;
  readonly documentTail: string | null;
  readonly registeredSince: string | null;
  readonly listUpdatedAt: string | null;
  readonly queriedOn: string;
  readonly outcome: string | null;
  readonly sourceId: string;
  /** Klic hlasky o tvaru cisla dokladu (`invalid_format`), jinak `null`. */
  readonly formatMessageKey: string | null;
}

export async function checkDocumentValidity(
  documentType: DocumentCheckType,
  documentNumber: string,
): Promise<DocumentCheckResultDto> {
  return (await unwrap(
    apiClient.POST('/v1/parties/document-check', { body: { documentType, documentNumber } }),
  )) as DocumentCheckResultDto;
}
